import { createContext, useContext, useState } from "react";

const FinancialContext = createContext();

export function FinancialProvider({ children }) {
  // states
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [savedDataTable, setSavedDataTable] = useState(null);
  const [filter, setFilter] = useState(null);
  const [isVisibleButtons, setIsVisibleButtons] = useState(true);

  return (
    <FinancialContext.Provider
      value={{
        selectedCustomers,
        setSelectedCustomers,
        savedDataTable,
        setSavedDataTable,
        filter,
        setFilter,
        isVisibleButtons,
        setIsVisibleButtons,
      }}
    >
      {children}
    </FinancialContext.Provider>
  );
}

export function useFinancialContext() {
  return useContext(FinancialContext);
}
